<template>
    <el-dialog v-model="dialogVisibles" width="30%" :show-close="showClone" :before-close="handleClose">
        <div slot="title" class="text-box">
            <img src="../../assets/images/login/I.png">
            <span class="title-text">{{ title }}</span>
        </div>
        <div>{{ msg }}</div>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="btnFlag" @click="cancel">{{$t('universality.cancel')}}</el-button>
            <!-- <el-button type="primary" :style="{background:(dialogVisible?setStyle():setStyle())}" @click="confirm">确 定</el-button> -->
            <el-button type="primary" :style="{background:setStyle.bakcground,border: setStyle.border}" @click="confirm">{{$t('universality.confirm')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { defineComponent, computed, reactive, onMounted, toRefs } from 'vue'

export default defineComponent({
    emits: ['off', 'on'],
    name: 'dialogs',
    props: {
        dialogVisibles: {
            type: Boolean,
            default: false
        },
        msg: {
            type: String,
            default: ''
        },
        // 是否右上角关闭按钮  
        showClone: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '提示'
        },
        // 是否需要取消按钮
        btnFlag: {
            type: Boolean,
            default: true
        },
        buttonColor: {
            type: String,
            default: ''
        },
        borderColor: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: true
        }
    },
    setup(props, { emit }) {
        const state = reactive({
            meassg: '',
        })


        const methods = reactive({
            // 弹窗右上角关闭按钮
            handleClose() {
                state.dialogVisible = false
            },
            cancel() {
                emit('off')
            },
            confirm() {
                emit('on')
            },
        })

        const setStyle = reactive({
            bakcground: `${props.buttonColor}`,
            border: `${props.buttonColor}`
        })
        return {
            ...toRefs(state),
            ...toRefs(methods),
            setStyle,
        }
    }
})
</script>

<style scoped>
.dialog-footer {
    text-align: right;
    margin-top: 30px;
}

.reds{
    background: red;
}
.text-box {
    padding: 20px 20px 10px;
    position: relative;
    top: -20px;
    left: -20px;
    display: flex;
    align-items: center;
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8500);
    line-height: 22px;
}

.title-text {
    margin-left: 10px;
}
</style>